<script setup lang="ts">
import {Box, Images, Lightbulb} from 'lucide-vue-next'
import {useRoute, useRouter} from 'vue-router'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import {nextSectionIds, type NextSectionId} from '@shared/next'

const router = useRouter()
const route = useRoute()
const emit = defineEmits<{close: []}>()

const icons = {concepts: Lightbulb, entities: Box, cards: Images} as const
const items: ReadonlyArray<{key: NextSectionId; label: string}> = nextSectionIds.map((key) => ({
  key,
  label: `cp.nextSections.${key}`,
}))

function go(section: NextSectionId): void {
  void router.push(`/cp/next/${section}`)
  emit('close')
}
</script>

<template>
  <SidebarGroup class="mt-2 border-t border-sidebar-border pt-3 group-data-[collapsible=icon]:px-0">
    <SidebarGroupLabel>{{ $t('cp.next') }}</SidebarGroupLabel>
    <SidebarGroupContent>
      <SidebarMenu>
        <SidebarMenuItem v-for="item in items" :key="item.key">
          <SidebarMenuButton
            :is-active="route.path.startsWith(`/cp/next/${item.key}`)"
            :tooltip="$t(item.label)"
            :data-testid="`next-nav-${item.key}`"
            @click="go(item.key)">
            <component :is="icons[item.key]" class="size-4" />
            <span>{{ $t(item.label) }}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>
</template>
